import {
  updateResourceState,
  normalizeResourceState,
  createResourceReducer,
  RESOURCE,
  RECORD_FIELD,
  RESOURCE_CREATE,
  RESOURCE_CREATE_FINISHED
} from 'react-structure-admin';
import {
  USER,
  USER_UPDATE_PASSWORD,
  USER_SAVE_PASSWORD,
  USER_SAVE_PASSWORD_FINISHED,
  USER_SAVE_PASSWORD_FAILED,
  USER_CURRENT_UPDATE_FINISHED,
  USER_CURRENT_UPDATE_FAILED,
  USER_CURRENT_UPDATE,
  USER_CURRENT_GET,
  USER_CURRENT_GET_FINISHED,
  USER_SETTINGS_CURRENT_GET_FINISHED,
  USER_CURRENT_CANCEL,
  USER_REPORT_CANCEL,
  USER_REPORT_FAIL,
  USER_REPORT_SEND,
  USER_REPORT_SEND_FINISHED,
  USER_REPORT_INITIALIZE,
  USER_CREATE_CONTRIBUTOR,
  USER_CREATE_CONTRIBUTOR_FINISHED,
  USER_CANCEL_INVITATION_FINISHED,
  USER_CONFIRM_EMAIL_FINISHED,
  USER_GET_TENANT_SETTINGS,
  USER_GET_TENANT_SETTINGS_FINISHED,
  USER_CLOSE_TENANT_SETTINGS,
  USER_UPDATE_TENANT_SETTINGS,
  USER_UPDATE_TENANT_SETTINGS_FINISHED,
  USER_REMOVE_TENANT_FINISHED,
  USER_SET_EDITING_BY_ADMIN,
  USER_SET_INITIAL_TAB
} from './userActions';

const userReducer = createResourceReducer(USER, [], {
  [USER_UPDATE_PASSWORD](state, action) {
    const newState = normalizeResourceState(state, action.resource);
    return updateResourceState(newState, action, RECORD_FIELD, () => ({
      editingPassword: action.payload,
      visible: true,
      loading: false
    }));
  },

  [USER_SAVE_PASSWORD](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: true
    }));
  },

  [USER_SAVE_PASSWORD_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, (resource) => ({
      [RECORD_FIELD]: {
        ...resource[RECORD_FIELD],
        editingPassword: null
      },
      loading: false,
      visible: false
    }));
  },

  [USER_SAVE_PASSWORD_FAILED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: false
    }));
  },

  [USER_SET_EDITING_BY_ADMIN](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      editingByAdmin: true
    }));
  },

  [USER_SET_INITIAL_TAB](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      initialTab: action.payload
    }));
  },

  [USER_CURRENT_GET_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      currentUser: action.payload.data.result,
      visible: true
    }));
  },

  [USER_SETTINGS_CURRENT_GET_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      currentUser: action.payload.data.result,
      editingCurrentUser: true,
      visible: true
    }));
  },

  [USER_CURRENT_UPDATE](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      currentUser: action.payload,
      loading: true
    }));
  },

  [USER_CURRENT_UPDATE_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      currentUser: null,
      editingCurrentUser: false,
      visible: false,
      loading: false,
      loaded: false,
      initialTab: null
    }));
  },

  [USER_CURRENT_UPDATE_FAILED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: false
    }));
  },

  [USER_CURRENT_CANCEL](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      currentUser: null,
      editingCurrentUser: false,
      visible: false,
      editingByAdmin: false,
      initialTab: null
    }));
  },

  [USER_REPORT_INITIALIZE](state, action) {
    const newState = normalizeResourceState(state, action.resource);

    if (action.payload.type === 'suggestion') {
      action.payload.title = 'Sugestão';
    } else {
      action.payload.title = 'Reportar problema';
    }

    return updateResourceState(newState, action, RESOURCE, () => ({
      report: { ...action.payload }
    }));
  },
  [USER_REPORT_CANCEL](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      report: null
    }));
  },
  [USER_REPORT_FAIL](state, action) {
    return updateResourceState(state, action, RESOURCE, (resource) => ({
      report: { ...resource.report, loading: false }
    }));
  },
  [USER_REPORT_SEND](state, action) {
    return updateResourceState(state, action, RESOURCE, (resource) => ({
      report: { ...resource.report, loading: true }
    }));
  },

  [USER_REPORT_SEND_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      report: null
    }));
  },

  [USER_CREATE_CONTRIBUTOR](state, action) {
    const newState = normalizeResourceState(state, action.resource);
    return {
      ...newState,
      [action.resource]: {
        ...newState[action.resource],
        editing: true,
        saving: true,
        resourceToEdit: action.payload
      }
    };
  },

  [USER_CREATE_CONTRIBUTOR_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      saving: false,
      editing: false,
      action: null,
      loaded: false
    }));
  },

  [USER_CANCEL_INVITATION_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loaded: false
    }));
  },

  [USER_CONFIRM_EMAIL_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loaded: false
    }));
  },

  [USER_GET_TENANT_SETTINGS](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      userIdTenantSettingsEditing: action.payload
    }));
  },

  [USER_UPDATE_TENANT_SETTINGS](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      userTenantSettingsEditing: action.payload,
      saving: true
    }));
  },

  [USER_UPDATE_TENANT_SETTINGS_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      userTenantSettingsEditing: null,
      saving: false
    }));
  },

  [USER_GET_TENANT_SETTINGS_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      userTenantSettingsEditing: action.payload.data.result,
      loadingEdition: true
    }));
  },

  [USER_CLOSE_TENANT_SETTINGS](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      userTenantSettingsEditing: null,
      userIdTenantSettingsEditing: null,
      loadingEdition: false
    }));
  },

  [USER_REMOVE_TENANT_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loaded: false
    }));
  }
});

export default userReducer;
